import { render, staticRenderFns } from "./CampaignStats.vue?vue&type=template&id=33edf5e4&scoped=true&"
import script from "./CampaignStats.vue?vue&type=script&lang=js&"
export * from "./CampaignStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33edf5e4",
  null
  
)

export default component.exports